import { TransactionalEventsRepository } from '@core/repositories/transactional-events.repository';
import { TransactionalEvent } from '@shared/interfaces/transactional-event';
import { Observable, of, throwError } from 'rxjs';

interface ResultStatus {
  id: string;
  attributes: {
    name: string;
  };
}

export class FakeTransactionalEventsRepository implements TransactionalEventsRepository {
  url: string;

  dataStatus: Array<ResultStatus> = [
    {
      id: '301',
      attributes: {
        name: 'Enviar'
      }
    },
    {
      id: '401',
      attributes: {
        name: 'Pagar'
      }
    },
    {
      id: '501',
      attributes: {
        name: 'Cancelar'
      }
    }
  ];

  transactionalEvents = {
    data: this.dataStatus
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.transactionalEvents);
  }

  add(transactionalEvent: TransactionalEvent): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(transactionalEvent: TransactionalEvent): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
